import DialogFunctions from "../../../core/dialogFunctions";

class AddBackupPlanDialogController extends DialogFunctions {
  constructor($mdDialog) {
    "ngInject";

    super($mdDialog);
  }
}

export default AddBackupPlanDialogController;



// WEBPACK FOOTER //
// ./src/pages/backupplans/addBackupPlansDialog/addBackupPlansDialog.controller.js